import { DoubleSide } from "three"
import { a } from "@react-spring/three"
import { useStore } from "../state/store"
import { returnsPlotNumber } from "../components/ApartmentFinder/Utils/Helpers"

let avColors = { 1: "#F57A87", 2: "#75B2EB", 3: "#69CF9C", 4: "#F2E291" }

export function ApartmentMaterial({ name, map, available, beds, status }) {
  const apartmentFinderActive = useStore(s => s.apartmentFinderActive)
  const favourites = useStore(s => s.favourites)
  const favouritesActive = useStore(s => s.favouritesActive)
  const activeApt = useStore(s => s.activeApt)

  let isInfav = favourites.includes(returnsPlotNumber(name))

  let colour
  if (apartmentFinderActive) {
    if (available || activeApt) {
      if (status === "0") {
        colour = avColors[beds]
      } else {
        if (status === "1") {
          colour = "#E3E3E3"
        }
      }
    } else {
      colour = "#E3E3E3"
    }
  } else {
    colour = "#E3E3E3"
  }

  if (favouritesActive) {
    if (isInfav) {
      return (
        <a.meshStandardMaterial
          side={DoubleSide}
          color={"#0078D7"}
          transparent={false}
          flatShading={true}
          toneMapped={false}
          opacity={1}
          map={ApartmentMaterial ? null : map}
        />
      )
    } else {
      return (
        <a.meshStandardMaterial
          side={DoubleSide}
          color={colour}
          transparent={true}
          flatShading={true}
          toneMapped={false}
          opacity={0.1}
          map={ApartmentMaterial ? null : map}
        />
      )
    }
  } else {
    return (
      <a.meshStandardMaterial
        side={DoubleSide}
        color={colour}
        transparent={true}
        flatShading={true}
        toneMapped={false}
        opacity={1}
        map={ApartmentMaterial ? null : map}
      />
    )
  }
}
export function ArchiMaterial({ name, map, opacity }) {
  const favouritesActive = useStore(s => s.favouritesActive)

  // const alpha = useTexture(
  //   `${process.env.PUBLIC_URL}/assets/apartmentfinder/textures/metal_alpha_0_d.jpg`
  // )

  if (favouritesActive) {
    return (
      <meshPhysicalMaterial transparent={true} opacity={0.1} color="black" flatShading={true} />
    )
  } else {
    if (name.includes("metal_alpha_0")) {
      return (
        <meshBasicMaterial
          side={DoubleSide}
          transparent={false}
          // map={alpha}
          opacity={0}
          // color={"red"}
        />
      )
    } else {
      return <a.meshBasicMaterial side={DoubleSide} transparent={1} opacity={opacity} map={map} />
    }
  }
}

// export const Meshcolours = {
//   notActive: "#BE1B38",
//   sold: "#E3E3E3",
//   hide: "#E3E3E3",
//   reserved: "#4A4A4A",
//   unreleased: "#5B89B5",
//   oneBed: "#B83B47",
//   twoBed: "#1F578C",
//   threeBed: "#227D4F",
//   fourBed: "#DBC555",
//   filtered: "#E3E3E3"
// }

// const favourite = new MeshStandardMaterial({
//   color: "#0078D7",
//   side: DoubleSide,
//   flatShading: true
// })

// const notFavourite = new MeshPhysicalMaterial({
//   opacity: 0.1,
//   transparent: true,
//   color: "#000",
//   flatShading: true
// })

// const one_bed = new MeshStandardMaterial({
//   // color: "#white",
//   // map: diffuse,
//   color: Meshcolours.oneBed,
//   side: DoubleSide,
//   flatShading: true
//   // envMapIntensity: isIOS ? 2.6 : 1
// })
// const two_bed = new MeshStandardMaterial({
//   // color: "#white",
//   color: Meshcolours.twoBed,
//   flatShading: true,
//   side: DoubleSide
//   // envMapIntensity: isIOS ? 2.6 : 1
// })
// const three_bed = new MeshStandardMaterial({
//   color: Meshcolours.threeBed,
//   side: DoubleSide,
//   flatShading: true

//   // envMapIntensity: isIOS ? 2.6 : 1
// })
// const studio = new MeshStandardMaterial({
//   color: Meshcolours.fourBed,
//   side: DoubleSide,
//   flatShading: true

//   // envMapIntensity: isIOS ? 2.6 : 1
// })
// const sold_mat = new MeshStandardMaterial({
//   // color: "#white",
//   color: Meshcolours.sold,
//   flatShading: true
//   // envMapIntensity: isIOS ? 2.6 : 1
// })
// const reserved_mat = new MeshStandardMaterial({
//   // color: "#white",
//   color: Meshcolours.reserved,
//   // map: diffuse,
//   flatShading: true
//   // envMapIntensity: isIOS ? 2.6 : 1
// })
// const unreleased_mat = new MeshStandardMaterial({
//   // color: "#white",
//   color: Meshcolours.reserved,
//   // map: diffuse,
//   flatShading: true
//   // envMapIntensity: isIOS ? 2.6 : 1
// })
// const original_mat = new MeshStandardMaterial({
//   // color: "#white",
//   color: "#0f0",
//   // map: diffuse,
//   flatShading: true
//   // envMapIntensity: isIOS ? 2.6 : 1
// })

// export const getApartmentMaterial = (
//   favouritesActive,
//   isInFavourites,
//   apartmentFinderActive,
//   beds,
//   status,
//   inFilter,
//   diffuse
// ) => {
//   let test = new MeshBasicMaterial({
//     map: diffuse
//   })
//   console.log("inFilter", inFilter)
//   //////////////////////////////
//   if (apartmentFinderActive) {
//     if (favouritesActive) {
//       if (isInFavourites) {
//         return favourite
//       }
//       return notFavourite
//     }
//     console.log(status)
//     if (inFilter) {
//       if (beds === "0") {
//         // one_bed.map = diffuse
//         return studio
//       } else if (beds === "1") {
//         // one_bed.map = diffuse
//         return one_bed
//       } else if (beds === "2") {
//         // two_bed.map = diffuse
//         return two_bed
//       } else if (beds === "3") {
//         // three_bed.map = diffuse
//         return three_bed
//       }
//     } else if (status === "1") {
//       // sold_mat.map = diffuse
//       return sold_mat
//     } else if (status === "2") {
//       // reserved_mat.map = diffuse
//       return reserved_mat
//     } else if (status === "4") {
//       // reserved_mat.map = diffuse
//       return unreleased_mat
//     } else {
//       // hidden_mat.map = diffuse
//       return new MeshStandardMaterial({
//         color: "blue",
//         map: diffuse
//       })
//     }
//     // }
//   } else {
//     original_mat.map = diffuse

//     return test
//   }
// }

// export const getMaterial = (type, isActive, diffuse) => {
//   // console.log(type)
//   let material

//   if (type === "G") {
//     material = new MeshPhysicalMaterial({
//       // color: "orange",
//       color: "#000",
//       roughness: 0,
//       opacity: 0.2,
//       side: DoubleSide,
//       transmission: 1,
//       transparent: true,
//       reflectivity: 1
//     })
//     return material
//   } else {
//     if (isActive) {
//       material = new MeshStandardMaterial({
//         color: colours.offWhite,
//         side: DoubleSide,
//         flatShading: true,
//         envMapIntensity: 0.4
//       })
//       return material
//     } else if (type === "M") {
//       material = new MeshPhysicalMaterial({
//         map: diffuse,
//         side: DoubleSide,
//         reflectivity: 1,
//         // metalness: 0.2
//         roughness: 0
//         // flatShading: true,
//         // envMapIntensity: isIOS ? 2.6 : 1
//       })
//       return material
//     } else {
//       material = new MeshBasicMaterial({
//         map: diffuse,
//         side: DoubleSide
//         // flatShading: true,
//         // envMapIntensity: isIOS ? 2.6 : 1
//       })
//       return material
//     }
//   }
// }
